// Links that open the bot's chat with a command already typed into the input (`t.me/<username>?text=<draft_text>`,
// `ai/references/https/core.telegram.org/api/links/_.md`).

export interface CommandLinkOptions {
  // The command takes parameters: a trailing space is added so the user can type them straight away.
  args?: boolean
}

export function commandText(command: string): string {
  return `/${command.replace(/^\//, '')}`
}

export function commandLink(botUsername: string, command: string, options: CommandLinkOptions = {}): string {
  const draft = commandText(command) + (options.args ? ' ' : '')
  return `https://t.me/${encodeURIComponent(botUsername.replace(/^@/, ''))}?text=${encodeURIComponent(draft)}`
}
